/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import GameControllerDtoConfigItemListRequest from '../model/GameControllerDtoConfigItemListRequest';
import GameControllerDtoConfigItemListResponse from '../model/GameControllerDtoConfigItemListResponse';
import GameControllerDtoGameConfigCreateRequest from '../model/GameControllerDtoGameConfigCreateRequest';
import GameControllerDtoGameConfigInfoResponse from '../model/GameControllerDtoGameConfigInfoResponse';
import GameControllerDtoGameConfigRemoveRequest from '../model/GameControllerDtoGameConfigRemoveRequest';
import GameControllerDtoGameConfigRemoveResponse from '../model/GameControllerDtoGameConfigRemoveResponse';
import GameControllerDtoGameConfigUpdateRequest from '../model/GameControllerDtoGameConfigUpdateRequest';
import GameControllerDtoGameConfigUpdateResponse from '../model/GameControllerDtoGameConfigUpdateResponse';
import GameControllerDtoMaterialConfigCheckResponse from '../model/GameControllerDtoMaterialConfigCheckResponse';
import GameControllerDtoMaterialConfigInfoResponse from '../model/GameControllerDtoMaterialConfigInfoResponse';

/**
* PerplayGame service.
* @module api/PerplayGameApi
* @version 1.0
*/
export default class PerplayGameApi {

    /**
    * Constructs a new PerplayGameApi. 
    * @alias module:api/PerplayGameApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayGameConfigItemListPost operation.
     * @callback module:api/PerplayGameApi~apiPerplayGameConfigItemListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameControllerDtoConfigItemListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GameControllerDtoConfigItemListRequest} [gameControllerDtoConfigItemListRequest] 
     * @param {module:api/PerplayGameApi~apiPerplayGameConfigItemListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameControllerDtoConfigItemListResponse}
     */
    apiPerplayGameConfigItemListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['gameControllerDtoConfigItemListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = GameControllerDtoConfigItemListResponse;
      return this.apiClient.callApi(
        '/api/PerplayGame/ConfigItemList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayGameGameConfigCreatePost operation.
     * @callback module:api/PerplayGameApi~apiPerplayGameGameConfigCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GameControllerDtoGameConfigCreateRequest} [gameControllerDtoGameConfigCreateRequest] 
     * @param {module:api/PerplayGameApi~apiPerplayGameGameConfigCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayGameGameConfigCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['gameControllerDtoGameConfigCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayGame/GameConfigCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayGameGameConfigInfoPost operation.
     * @callback module:api/PerplayGameApi~apiPerplayGameGameConfigInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameControllerDtoGameConfigInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/PerplayGameApi~apiPerplayGameGameConfigInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameControllerDtoGameConfigInfoResponse}
     */
    apiPerplayGameGameConfigInfoPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = GameControllerDtoGameConfigInfoResponse;
      return this.apiClient.callApi(
        '/api/PerplayGame/GameConfigInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayGameGameConfigRemovePost operation.
     * @callback module:api/PerplayGameApi~apiPerplayGameGameConfigRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameControllerDtoGameConfigRemoveResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GameControllerDtoGameConfigRemoveRequest} [gameControllerDtoGameConfigRemoveRequest] 
     * @param {module:api/PerplayGameApi~apiPerplayGameGameConfigRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameControllerDtoGameConfigRemoveResponse}
     */
    apiPerplayGameGameConfigRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['gameControllerDtoGameConfigRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = GameControllerDtoGameConfigRemoveResponse;
      return this.apiClient.callApi(
        '/api/PerplayGame/GameConfigRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayGameGameConfigUpdatePost operation.
     * @callback module:api/PerplayGameApi~apiPerplayGameGameConfigUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameControllerDtoGameConfigUpdateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/GameControllerDtoGameConfigUpdateRequest} [gameControllerDtoGameConfigUpdateRequest] 
     * @param {module:api/PerplayGameApi~apiPerplayGameGameConfigUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameControllerDtoGameConfigUpdateResponse}
     */
    apiPerplayGameGameConfigUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['gameControllerDtoGameConfigUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = GameControllerDtoGameConfigUpdateResponse;
      return this.apiClient.callApi(
        '/api/PerplayGame/GameConfigUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayGameMaterialConfigCheckPost operation.
     * @callback module:api/PerplayGameApi~apiPerplayGameMaterialConfigCheckPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameControllerDtoMaterialConfigCheckResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {File} configFile 
     * @param {module:api/PerplayGameApi~apiPerplayGameMaterialConfigCheckPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameControllerDtoMaterialConfigCheckResponse}
     */
    apiPerplayGameMaterialConfigCheckPost(configFile, callback) {
      let postBody = null;
      // verify the required parameter 'configFile' is set
      if (configFile === undefined || configFile === null) {
        throw new Error("Missing the required parameter 'configFile' when calling apiPerplayGameMaterialConfigCheckPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'ConfigFile': configFile
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = GameControllerDtoMaterialConfigCheckResponse;
      return this.apiClient.callApi(
        '/api/PerplayGame/MaterialConfigCheck', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayGameMaterialConfigInfoPost operation.
     * @callback module:api/PerplayGameApi~apiPerplayGameMaterialConfigInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GameControllerDtoMaterialConfigInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/PerplayGameApi~apiPerplayGameMaterialConfigInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GameControllerDtoMaterialConfigInfoResponse}
     */
    apiPerplayGameMaterialConfigInfoPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = GameControllerDtoMaterialConfigInfoResponse;
      return this.apiClient.callApi(
        '/api/PerplayGame/MaterialConfigInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayGameMaterialConfigUpdatePost operation.
     * @callback module:api/PerplayGameApi~apiPerplayGameMaterialConfigUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {File} configFile 
     * @param {module:api/PerplayGameApi~apiPerplayGameMaterialConfigUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayGameMaterialConfigUpdatePost(configFile, callback) {
      let postBody = null;
      // verify the required parameter 'configFile' is set
      if (configFile === undefined || configFile === null) {
        throw new Error("Missing the required parameter 'configFile' when calling apiPerplayGameMaterialConfigUpdatePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'ConfigFile': configFile
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayGame/MaterialConfigUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
